import useReveal from "@/hooks/useReveal";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import { Toaster } from "@/components/ui/sonner";

/**
 * Shared shell for inner editorial pages: Header + main + Footer + scroll reveal.
 */
export default function PageShell({ children }) {
  useReveal([]);
  return (
    <div className="min-h-screen bg-white font-body text-[#1e293b]">
      <Header />
      <main className="pt-24 md:pt-28">{children}</main>
      <Footer />
      <Toaster position="bottom-center" />
    </div>
  );
}
